import { createUseStyles } from 'react-jss';
import { ActionPalette } from '@tcl-boron-colors/colors';
import { Classes } from 'jss';

const buttonReset = {
  border: 'none',
  backgroundColor: 'unset',
  color: 'white',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: 500,
};

export const useMonthYearInputStyles: (data?: {
  theme?: Jss.Theme;
}) => Classes<
  | 'header'
  | 'changeMonthContainer'
  | 'changeMonthControl'
  | 'currentMonthYear'
  | 'yearDropdownOpen'
  | 'checkmark'
  | 'caret'
  | 'monthYear'
  | 'root'
> = createUseStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '272px',
    alignItems: 'center',
    paddingTop: '11px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: ActionPalette[600],
  },
  changeMonthContainer: {
    marginRight: '24px',
    display: 'flex',
    gap: '0px 8px',
  },
  changeMonthControl: {
    cursor: 'pointer',
  },
  currentMonthYear: {
    ...buttonReset,
  },
  yearDropdownOpen: {
    display: 'block',
  },
  checkmark: {
    left: '33%',
    position: 'absolute',
  },
  caret: {
    marginLeft: '6px',
  },
  monthYear: {
    marginLeft: '24px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '20px',
  },
});
